<template lang='pug'>
  #brand-accordion.accordion.accordion-sidebar(v-if='showBrandsInfo' role='tablist')
    .card.card-light.brand-accordion-mobile
      #about-brand-heading.collapsed(data-toggle='collapse' data-target='#about-brand-collapse' role='tab')
        i.collapse-arrow
        h4.h4(v-text='$t("products.brand.aboutTheBrand")')

      #about-brand-collapse.collapse(aria-labelledby='about-brand-heading' role='tabpanel' data-parent='#brand-accordion')
        .brand-info(v-text='entity.attributes["description"]')
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType
    }),

    showBrandsInfo () {
      return this.entityType === 'brands' && this.entity.attributes && (this.entity.attributes['seo']['description'] || this.entity.attributes['description'])
    }
  }
}
</script>

<style lang='scss' scoped>
  .brand-accordion-mobile {
    border-width: 2px !important;
    border-bottom: 0;
  }

  #about-brand-heading {
    padding: 10px 16px;

    .h4 {
      @include font-weight-bold;
      text-transform: uppercase;
    }
  }

  .brand-info {
    padding: 10px 16px;
    word-wrap: break-word;
  }
</style>
